import {Box, Button, Stack} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import FileUploadIcon from '@mui/icons-material/FileUpload';

const Actions = ({
                     onBodyChange,
                     onEyesChange,
                     onHairChange,
                     onOutlineChange,
                 }) => {
    return <>
        <Stack spacing={2} direction="column">
            <Button
                component="label"
                endIcon={<FileUploadIcon/>}
            >
                Body shape
                <input hidden type="file" accept=".png" onChange={onBodyChange}/>
            </Button>

            <Button
                component="label"
                endIcon={<FileUploadIcon/>}
            >
                Eyes Shape
                <input hidden type="file" accept=".png" onChange={onEyesChange}/>
            </Button>

            <Button
                component="label"
                endIcon={<FileUploadIcon/>}
            >
                Hair shape
                <input hidden type="file" accept=".png" onChange={onHairChange}/>
            </Button>

            <Button
                component="label"
                endIcon={<FileUploadIcon/>}
            >
                Outline
                <input hidden type="file" accept=".png" onChange={onOutlineChange}/>
            </Button>
        </Stack>
    </>
}

export default Actions;